module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mc-upload-wrap video-upload-warp"
  }, [(_vm.workMode === 'upload-outer') ? _c('div', {
    staticClass: "isout-switch-wrap hf"
  }, [_c('div', {
    staticClass: "label ftp"
  }, [_vm._v("Is OutLink")]), _vm._v(" "), _c('div', {
    staticClass: "ftp"
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    on: {
      "change": _vm.changeOuter
    },
    model: {
      value: (_vm.isOuterUrl),
      callback: function($$v) {
        _vm.isOuterUrl = $$v
      },
      expression: "isOuterUrl"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), ((_vm.workMode === 'upload-outer' || _vm.workMode === 'outer') && _vm.isOuterUrl === true) ? [_c('el-input', {
    attrs: {
      "size": "small"
    },
    on: {
      "change": _vm.outerIptChange
    },
    model: {
      value: (_vm.videoUrl),
      callback: function($$v) {
        _vm.videoUrl = $$v
      },
      expression: "videoUrl"
    }
  })] : _vm._e(), _vm._v(" "), ((_vm.workMode === 'upload-outer' || _vm.workMode === 'upload') && _vm.isOuterUrl === false) ? [_c('div', {
    directives: [{
      name: "fileupload",
      rawName: "v-fileupload",
      value: (_vm.videoUrl),
      expression: "videoUrl"
    }],
    staticClass: "upload-field",
    class: {
      'has-upload': _vm.videoUrl
    },
    style: ({
      width: _vm.width + 'px'
    }),
    on: {
      "upload-change": _vm.videoUploadSuccess
    }
  }, [_c('div', {
    staticClass: "tip"
  }, [_vm._v("UPLOAD")]), _vm._v(" "), _c('div', {
    staticClass: "pic-wrap"
  }, [_c('video', {
    attrs: {
      "src": _vm.videoUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "upload-cover"
  }, [_vm._v("Change")])])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-30d9ce1d","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/libcomponents/video-upload/video-upload.vue
// module id = 752
// module chunks = 1